<template>
  <header class="topo">
    <div class="topo-titulo">
      <h1>{{ $route.meta.titulo || 'Clockin' }}</h1>
      <span class="filial"><i class="bi bi-building"></i> {{ usuario.descfilialpadrao || 'Empresa ' + usuario.idempresa }}</span>
    </div>
    <div class="topo-usuario">
      <div class="avatar" :title="usuario.nomeusuario">{{ iniciais }}</div>
      <div class="dados">
        <strong>{{ usuario.nomeusuario || 'Usuário' }}</strong>
        <small>Empresa {{ usuario.idempresa }}</small>
      </div>
      <button class="sair" @click="sair" title="Sair">
        <i class="bi bi-box-arrow-right"></i>
      </button>
    </div>
  </header>
</template>

<script>
import util from '@/util';

export default {
  name: 'mcabecalho',
  computed: {
    usuario() {
      return this.$store.state.usuario || {}
    },
    iniciais() {
      const n = String(this.usuario.nomeusuario || 'U').trim().split(/\s+/)
      return ((n[0] || '')[0] + ((n[1] || '')[0] || '')).toUpperCase()
    },
  },
  methods: {
    sair() {
      util.logoff();
    },
  },
}
</script>

<style scoped lang="scss">
.topo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background: rgba(255, 255, 255, .85);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--ck-borda);
  position: sticky;
  top: 0;
  z-index: 50;
}
.topo-titulo { display: flex; align-items: baseline; gap: 14px; min-width: 0; }
.topo-titulo h1 { font-size: 1.1rem; font-weight: 700; margin: 0; white-space: nowrap; }
.filial { color: var(--ck-texto-2); font-size: .82rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.topo-usuario { display: flex; align-items: center; gap: 10px; }
.avatar {
  width: 36px; height: 36px; border-radius: 50%;
  background: var(--ck-primaria-suave); color: var(--ck-primaria);
  display: grid; place-items: center; font-weight: 700; font-size: .85rem;
}
.dados { display: flex; flex-direction: column; line-height: 1.15; }
.dados strong { font-size: .85rem; }
.dados small { color: var(--ck-texto-2); font-size: .74rem; }
.sair { border: 0; background: transparent; color: var(--ck-texto-2); font-size: 1.15rem; padding: 6px 8px; border-radius: 8px; }
.sair:hover { background: #fdecea; color: var(--ck-perigo); }
@media (max-width: 640px) {
  .dados, .filial { display: none; }
  .topo { padding: 0 14px; }
}
</style>
